import PropTypes from 'prop-types';
import React from 'react';

import {DateTime} from 'luxon';
import Helmet from 'react-helmet';

import Link from '../components/Link';
import Project from '../components/Project';

import githubIcon from '!raw!simple-icons/icons/github.svg';

import {tags} from '!json-loader!yaml-loader!../../data/tags.yaml';

export default class IndexPage extends React.Component {
	static propTypes = {
		data: PropTypes.object,
	}

	render() {
		const {
			data: {
				intro,
				projects: {edges},
				interested,
				tools,
			},
		} = this.props;

		const projects = edges.map(edge => edge.node);

		const isOld = (project) => {
			const parsedDate = DateTime.fromISO(project.frontmatter.date);
			return parsedDate < DateTime.fromISO('2017-11-01');
		};

		return (
			<div>
				<Helmet>
					<meta name="description" content="Bart Nagel – web developer in Vancouver, BC" />
				</Helmet>
				<h1 className="homeHeader">
					<img
						src="https://www.gravatar.com/avatar/b6bb26d2d5df67f05a6eabadedccf5d3?s=28"
						srcSet="
							https://www.gravatar.com/avatar/b6bb26d2d5df67f05a6eabadedccf5d3?s=28 28w,
							https://www.gravatar.com/avatar/b6bb26d2d5df67f05a6eabadedccf5d3?s=42 42w,
							https://www.gravatar.com/avatar/b6bb26d2d5df67f05a6eabadedccf5d3?s=56 56w,
							https://www.gravatar.com/avatar/b6bb26d2d5df67f05a6eabadedccf5d3?s=84 84w,
						"
						width="28" height="28"
						sizes="0.691358em"
						alt="Bart Nagel's face"
						style={{
							height: '0.691358em',
							verticalAlign: 'baseline',
						}}
					/>
					{' '}
					Bart Nagel – web developer
				</h1>

				<section id="intro" dangerouslySetInnerHTML={{__html: intro.html}} />

				<h2>Project history</h2>
				<ul>
					{projects.filter(p => !isOld(p)).map((project) => (
						<li key={project.id}>
							<Project {...project.frontmatter} />
						</li>
					))}
				</ul>

				<details>
					<summary>The list goes way (way) on.</summary>
					<ul>
						{projects.filter(p => isOld(p)).map((project) => (
							<li key={project.id}>
								<Project {...project.frontmatter} />
							</li>
						))}
					</ul>
				</details>

				<section id="interested" dangerouslySetInnerHTML={{__html: interested.html}} />

				<section id="tools" dangerouslySetInnerHTML={{__html: tools.html}} />

				<section id="contact">
					<h2>Contact details</h2>
					<h3>Email</h3>
					<p>
						You can get <strong>my email address</strong> by taking
						b<strong>a</strong>rtnagel.ca
						and replacing the first <strong>a</strong> with <strong>@</strong>.
					</p>

					<p>
						If you wish, you can encrypt messages you send to me using <a href="/pgp/bart_nagel.pub.asc">my OpenPGP public key</a>.
						{' '}
						<span className="muted">(There’s also <a href="/pgp/bart_nagel_at_ecs.pub.asc">a legacy PGP key for ECS-related stuff</a>.)</span>
					</p>

					<h3>Web communities</h3>
					<ul>
						<li>
							<span className="icon" dangerouslySetInnerHTML={{__html: githubIcon}} />
							{' '}
							Github: <a href="https://github.com/tremby" aria-label="Bart Nagel on Github">tremby</a>
						</li>
					</ul>
				</section>
			</div>
		);
	}
}

export const pageQuery = graphql`
	query IndexQuery {
		projects: allMarkdownRemark(
			filter: {
				fileAbsolutePath: {
					regex: "/\\/data\\/projects\\/[^/]+\\.md$/",
				},
			},
			sort: {
				order: DESC,
				fields: [frontmatter___date],
			},
		) {
			edges {
				node {
					id
					frontmatter {
						date
						featured
						path
						summary
						taskSummary
						title
						url
					}
				}
			}
		}
		intro: markdownRemark(
			fileAbsolutePath: {
				regex: "/\\/data\\/snippets\\/index\\/intro\\.md$/",
			}
		) {
			html
		}
		interested: markdownRemark(
			fileAbsolutePath: {
				regex: "/\\/data\\/snippets\\/index\\/interested\\.md$/",
			}
		) {
			html
		}
		tools: markdownRemark(
			fileAbsolutePath: {
				regex: "/\\/data\\/snippets\\/index\\/tools\\.md$/",
			}
		) {
			html
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/index.js